// extracted by mini-css-extract-plugin
export default {"loader":"_loader_loader__GVoJy","rotate":"_loader_rotate__73OWa"};